import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/plugins/vant'
import '@/plugins/ls'
import '@/plugins/bus'
import '@/plugins/v-console'
import '@/plugins/meta'
import '@/directives'
import '@/filters'

import '@/assets/css/common.scss'

Vue.config.productionTip = false
// HACK: 设置忽略组件名称。 微信小程序跳转按钮
Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
